/**
 * This page is used for a labeler to review their QA feedback
 */
import { useParams } from "react-router-dom";
import { OosConfirmationContent } from "../components/OosConfirmationContent";
import { LoadingOverlay } from "@mantine/core";
import { RESULTS_SIDEBAR_WIDTH } from "@/config/data";
import { ConfirmationResultsSidebar } from "@/components/ConfirmationResultsSidebar";
import { isEmpty } from "lodash";
import { useSearchParams } from "react-router-dom";
import {
  useFetchTask,
  useFetchJob,
} from "@labeling-tools/api/lebron/react-query-hooks";
import { ViewMode } from "@/types";
import { useMarkQaTaskReviewed } from "@/hooks/useMarkQaTaskReviewed";

export const OosConfirmationQaView = () => {
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");

  const { data: job } = useFetchJob(jobId || "");
  const { data: taskData, isLoading: taskLoading } = useFetchTask(
    jobId || "",
    taskId,
  );

  useMarkQaTaskReviewed(taskData);

  if (taskLoading) {
    return <LoadingOverlay />;
  }
  const hasResults = !!taskData?.result && !isEmpty(taskData.result);
  return (
    <div>
      {/* main content */}
      <div style={{ paddingRight: hasResults ? RESULTS_SIDEBAR_WIDTH : 0 }}>
        <OosConfirmationContent mode={ViewMode.CONFIRMATION_QA_FEEDBACK} />
      </div>

      {/* results sidebar */}
      {hasResults && (
        <ConfirmationResultsSidebar
          mode={ViewMode.CONFIRMATION_QA_FEEDBACK}
          task={taskData}
          testing={job?.testing}
        />
      )}
    </div>
  );
};
